import BaseModel from '@/models/base';

export default class User extends BaseModel {
  static entity = 'users';
  static apiPath = 'users';
  static routeName = 'user';

  static fields() {
    return {
      id: this.attr(null),
      full_name: this.string(''),
      email: this.string(''),
    };
  }
}
